import { SmartBannerEntity } from '@main/smart-banner/const';
import { StateUtils } from '@spartacus/core';
import { SMART_BANNER_ENTITY } from '../smart-banner-state';

export const LOAD_SMART_BANNER = '[Smart-banner] Smart-banner Load';
export const LOAD_SMART_BANNER_FAIL = '[Smart-banner] Smart-banner Load Fail';
export const LOAD_SMART_BANNER_SUCCESS = '[Smart-banner] Smart-banner Load Success';

export class LoadSmartBanner extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SMART_BANNER;

  constructor(public payload: string) {
    super(SMART_BANNER_ENTITY);
  }
}

export class LoadSmartBannerFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SMART_BANNER_FAIL;

  constructor(public payload: any) {
    super(SMART_BANNER_ENTITY, payload);
  }
}

export class LoadSmartBannerSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SMART_BANNER_SUCCESS;

  constructor(public payload: SmartBannerEntity | null) {
    super(SMART_BANNER_ENTITY);
  }
}

export type SmartBannerAction = LoadSmartBanner | LoadSmartBannerFail | LoadSmartBannerSuccess;
